import { usePostAccountRequest } from "@/entities/post-account-request/fetch";
import { useCallback } from "react";
import type { AccountRequestCreatePageProps } from "../model";

export const useAccountRequestCreatePageProps =
  (): AccountRequestCreatePageProps => {
    const postAccountRequest = usePostAccountRequest();

    const onAccountRequestSubmit: AccountRequestCreatePageProps["onAccountRequestSubmit"] =
      useCallback(
        (accountRequest) => {
          const officeName =
            accountRequest.officeName == null ||
            accountRequest.officeName === ""
              ? accountRequest.companyName
              : accountRequest.officeName;
          postAccountRequest.mutate({
            data: {
              ...accountRequest,
              officeName,
              // 単一選択値を配列に変換してAPIに送信
              companyCategory: [accountRequest.companyCategory],
            },
          });
        },
        [postAccountRequest],
      );
    return {
      requestStatus: postAccountRequest.isPending
        ? "submitting"
        : postAccountRequest.isSuccess
          ? "success"
          : postAccountRequest.isError
            ? "error"
            : "initial",
      errorMessage: null,
      onAccountRequestSubmit,
    };
  };
